<script>
const config = require(`../../../projects/${process.env.PROJECT}/front/configs/envs/${process.env.NODE_ENV}/config.json`)

export default {
  name: 'ConfigUtils',
  computed: {
    /**
     * @return {string}
     */
    PROJECT () {
      return config.project
    },
    /**
     * @return {string}
     */
    PROJECT_NAME () {
      const name = config.project.replaceAll('-', ' ')
      return name.charAt(0).toUpperCase() + name.slice(1)
    },
    /**
     * @return {number}
     */
    LATITUDE () {
      return parseFloat(config.latitude)
    },
    /**
     * @return {number}
     */
    LONGITUDE () {
      return parseFloat(config.longitude)
    },
    /**
     * @return {string}
     */
    CONFIG_WS_URL () {
      return config.wsConfigUrl
    },
    /**
     * @return {string}
     */
    WS_URL () {
      return config.wsUrl
    },
    /**
     * @return {string}
     */
    PREFIX_WS () {
      return config.prefixWs
    },
    /**
     * @return {string}
     */
    GOOGLE_ANALYTICS_CODE () {
      return config.googleAnalyticsCode
    },
    /**
     * @return {string}
     */
    GOOGLE_API_TOKEN () {
      return config.googleApiToken
    },
    /**
     * @return {string}
     */
    IATA () {
      return config.iata
    },
    /**
     * @return {string}
     */
    IATA_ARRIVO () {
      return config.iataArrivo
    },
    /**
     * @return {string}
     */
    COUNTRY_ARRIVO () {
      return config.countryArrivo
    },
    /**
     * @return {string}
     */
    REPARTO_ID () {
      return parseInt(config.repartoID)
    },
    /**
     * @return {string}
     */
    REPARTO_NAME () {
      return config.repartoName
    },
    /**
     * @return {string}
     */
    SEARCH_TOUR_LIMIT () {
      return parseInt(config.searchTourLimit)
    },
    /**
     * @return {string}
     */
    SEARCH_EXPERIENCE_LIMIT () {
      return parseInt(config.searchExperienceLimit)
    },
    /**
     * @return {string}
     */
    ITINERARIO_SERVICE_LIMIT () {
      return parseInt(config.itinerarioServiceLimit)
    },
    /**
     * @return {string}
     */
    HOME_VIDEO () {
      return config.homeVideo
    },
    /**
     * @return {boolean}
     */
    FAKE_ACTIVE () {
      return config.fake === 'true'
    },
    /**
     * @return {string}
     */
    KEACLOAK_GROUP () {
      return config.keycloakGroup
    },
    /**
     * @return {string}
     */
    META_KEYWORDS () {
      return config.metaKeywords
    },
    TITLE_IS_PROJECT () {
      return config.titleIsProject === 'true'
    },
    /**
     * @returns {number}
     */
    INTERVALLO_GIORNI_IN_RICERCA () {
      return parseInt(config.intervalloGiorniInRicerca)
    },
    /**
     * @returns {boolean}
     */
    HIDE_TOUR_IN_LOCO () {
      return config.hideTourInLoco === 'true'
    },
    /**
     * @returns {string}
     */
    HOTEL_SEARCH_LOCALITY () {
      return config.hotelSearchLocality
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/utils/ConfigUtils.vue